export default {"src":"/_next/static/media/noResults.f985f0d9.svg","height":424,"width":424,"blurWidth":0,"blurHeight":0};